<!--
 * @Description: 素材库
 * @Author: hasayake
 * @Date: 2020-05-07 11:19:30
 * @LastEditTime: 2020-05-20 13:45:43
 * @LastEditors: Please set LastEditors
-->

<template>
  <div class="material-factory">

    <section class="material-main">
      <filesManage  />
    </section>
  </div>
</template>

<script>
import filesManage from './filesManage'

export default {
  name: 'materialLibrary',

  components: {
    filesManage
  },

  data() {
    return {
      
    }
  }
}
</script>

<style lang="scss" scoped>
.material-factory {
    height: calc(100vh - 60px);
    overflow: auto;
  * {
    box-sizing: border-box;
  }

  .material-search {
    width: 600px;
    margin: 30px auto;

    .el-select {
      width: 100%;
    }
  }

  .material-main {
    width: 1200px;
    // height: calc(100vh - 200px);
    margin: 0 auto;
    // background-color: #fff;
    border-radius: 2px;;
    padding-top: 30px;
    padding-bottom: 30px;
  }
}
</style>
